import React, { useContext, useEffect, useRef } from 'react'
import { Image, View, Dimensions, Platform, Text, StyleSheet, Animated } from 'react-native'
import { LoginForm } from '../components/LoginForm/LoginForm'
import { globalStyle } from '../../../theme/global'
import { TemplatePage } from '../../../components/TemplatePage'
import { ChangeLanguage } from '../../../components/ChangeLanguage'
import { useKeyboardVisibility } from '../../../hooks/useKeyboardVisibility'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { DOBRA } from '../../../theme/fonts'
import { isDevelopment } from '@/utils/environment'
import { version } from '../../../../package.json'

const IS_DEVELOPMENT = isDevelopment()

const WIDTH_SCREEN = Dimensions.get('window').width * 0.7

export const LoginScreen = () => {
  const { lastUserLogged } = useContext(AuthContext)
  const { isKeyboardVisible } = useKeyboardVisibility()
  const blinkAnim = useRef(new Animated.Value(1)).current

  useEffect(() => {
    if (IS_DEVELOPMENT) {
      const blinkAnimation = Animated.loop(
        Animated.sequence([
          Animated.timing(blinkAnim, {
            toValue: 0.2,
            duration: 600,
            useNativeDriver: true,
          }),
          Animated.timing(blinkAnim, {
            toValue: 1,
            duration: 600,
            useNativeDriver: true,
          }),
        ]),
      )
      blinkAnimation.start()

      return () => blinkAnimation.stop()
    }
    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TemplatePage>
      {IS_DEVELOPMENT && (
        <View style={styles.developmentBanner}>
          <Text style={styles.developmentText}>
            <Animated.Text style={{ opacity: blinkAnim }}>⚠️ </Animated.Text>
            AMBIENTE DE DESARROLLO
          </Text>
        </View>
      )}
      <View style={{ padding: 8, flex: 1, gap: 8 }}>
        <View style={globalStyle.imgLogo}>
          <Image
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            source={require('../../../assets/aquachile-logo-login.png')}
            style={{
              width: Platform.OS !== 'web' ? (WIDTH_SCREEN < 800 ? WIDTH_SCREEN : 800) : 400,
              height:
                Platform.OS !== 'web'
                  ? WIDTH_SCREEN < 800
                    ? WIDTH_SCREEN * 0.2122
                    : 800 * 0.2122
                  : 400 * 0.2122,
            }}
          />
        </View>
        <LoginForm
          initialEmail={lastUserLogged?.remember ? lastUserLogged?.email ?? '' : ''}
          rememberUser={lastUserLogged?.remember ?? false}
          initialPassword={lastUserLogged?.remember ? lastUserLogged?.password ?? '' : ''}
        />
        <Text style={styles.versionText}>Versión {version}</Text>
      </View>
      {!isKeyboardVisible && <ChangeLanguage />}
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  versionText: { textAlign: 'center', color: 'white', fontFamily: DOBRA, marginTop: 8 },
  developmentBanner: {
    backgroundColor: '#DC2626',
    paddingVertical: 6,
    paddingHorizontal: 12,
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: '#991B1B',
  },
  developmentText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: DOBRA,
    textAlign: 'center',
  },
})
